import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { OverviewCard } from 'components/dashboard/components/overview-card';
import ReviewTable from 'components/dashboard/components/review-table';
import {
  FlexRow,
  HeaderFlexRow,
  HeadingTitle,
  Container,
  PlainButton,
} from 'components/styled-components';
import {
  StatContainer,
  BlueSection,
  DashboardContent,
  H2Dashboard,
} from 'components/dashboard/components/styled-components';
import * as actions from 'actions/vendor-request';
import colors from 'utils/colors';
import { getDashboardHeaders, getDashboardFields } from 'utils/functions';

const DashboardOverview = ({ awaitingCompletion, historical }) => (
  <StatContainer>
    <OverviewCard
      title="My ongoing assessments"
      icon="time"
      color={colors.icons.azure}
      data={awaitingCompletion}
      filterType="requestStatus"
      filter="Awaiting Third Party Completion"
    />
    <OverviewCard
      title="My historical assessments"
      icon="updated"
      color={colors.icons.amber}
      data={historical}
      filterType="statusCategory"
      filter={['pass', 'review', 'fail']}
    />
  </StatContainer>
);

class DashboardSponsor extends Component {
  componentDidMount() {
    this.props.fetchAllVendorRequests({ start: 0, limit: -1 });
  }

  render() {
    const { awaitingCompletion, historical, appUser } = this.props;
    return (
      <Container>
        <HeaderFlexRow>
          <HeadingTitle>Dashboard</HeadingTitle>
          <NavLink to="/new">
            <PlainButton>Create Assessment</PlainButton>
          </NavLink>
        </HeaderFlexRow>
        <BlueSection>
          <H2Dashboard>Assessments Overview</H2Dashboard>
          <DashboardOverview
            awaitingCompletion={awaitingCompletion['totalCount']}
            historical={historical['totalCount']}
          />
          <H2Dashboard>Recent Assessments</H2Dashboard>
        </BlueSection>

        <DashboardContent>
          <FlexRow flexWrap="wrap">
            <ReviewTable
              title="My Ongoing Assessments"
              data={awaitingCompletion}
              headers={getDashboardHeaders}
              fields={getDashboardFields}
              icon="time"
              color={colors.icons.azure}
              flexBasis="100%"
              filterType="requestStatus"
              filter="Awaiting Third Party Completion"
              appUser={appUser}
            />
            <ReviewTable
              title="My Historical Assessments"
              data={historical}
              headers={getDashboardHeaders}
              fields={getDashboardFields}
              icon="updated"
              color={colors.icons.amber}
              flexBasis="100%"
              filterType="statusCategory"
              filter={['pass', 'review', 'fail']}
              appUser={appUser}
            />
          </FlexRow>
        </DashboardContent>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  awaitingCompletion: state.vendorRequest.allRequestsInProgress,
  historical: state.vendorRequest.allRequestsNotInProgress,
});

DashboardSponsor = connect(
  mapStateToProps,
  actions
)(DashboardSponsor);

export default DashboardSponsor;
